module.exports = __webpack_public_path__ + "img/star-filled.ab63d5d0.svg";